import "./index.scss";

export const CheckoutPaymentFormInput = ({
  id,
  label,
  children,
  shortInput
}) => {
  return (
    <div className="checkout-payment-form-input">
      <label>
        {label}{" "}
        <abbr title="required" className="required">
          *
        </abbr>
      </label>
      <div
        id={id}
        className={`input-container${shortInput ? " short-input" : ""}`}
      />
      {children}
    </div>
  );
};
